import AddressButton from '@/components/address/HeaderAddress';
import { curPostCodeOrAddress } from '@/utils/addressRequestUtils';

export const AddressButtonServer = async () => {
  const postCodeResult = await curPostCodeOrAddress();

  return <AddressButton serverPostCode={postCodeResult} />;
};
